/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SelectField,
  SwitchField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { AppUsers } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function AppUsersUpdateForm(props) {
  const {
    id: idProp,
    appUsers: appUsersModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    Email: "",
    Enabled: false,
    GivenName: "",
    FamilyName: "",
    Phone: "",
    Groups: [],
  };
  const [Email, setEmail] = React.useState(initialValues.Email);
  const [Enabled, setEnabled] = React.useState(initialValues.Enabled);
  const [GivenName, setGivenName] = React.useState(initialValues.GivenName);
  const [FamilyName, setFamilyName] = React.useState(initialValues.FamilyName);
  const [Phone, setPhone] = React.useState(initialValues.Phone);
  const [Groups, setGroups] = React.useState(initialValues.Groups);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = appUsersRecord
      ? { ...initialValues, ...appUsersRecord }
      : initialValues;
    setEmail(cleanValues.Email);
    setEnabled(cleanValues.Enabled);
    setGivenName(cleanValues.GivenName);
    setFamilyName(cleanValues.FamilyName);
    setPhone(cleanValues.Phone);
    setGroups(cleanValues.Groups ?? []);
    setCurrentGroupsValue("");
    setErrors({});
  };
  const [appUsersRecord, setAppUsersRecord] = React.useState(appUsersModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(AppUsers, idProp)
        : appUsersModelProp;
      setAppUsersRecord(record);
    };
    queryData();
  }, [idProp, appUsersModelProp]);
  React.useEffect(resetStateValues, [appUsersRecord]);
  const [currentGroupsValue, setCurrentGroupsValue] = React.useState("");
  const GroupsRef = React.createRef();
  const getDisplayValue = {
    Groups: (r) => {
      const enumDisplayValueMap = {
        Administrator: "Administrator",
        Auditor: "Auditor",
        Contributor: "Contributor",
        Editor: "Editor",
      };
      return enumDisplayValueMap[r];
    },
  };
  const validations = {
    Email: [{ type: "Required" }],
    Enabled: [],
    GivenName: [],
    FamilyName: [],
    Phone: [],
    Groups: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Email,
          Enabled,
          GivenName,
          FamilyName,
          Phone,
          Groups,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            AppUsers.copyOf(appUsersRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "AppUsersUpdateForm")}
      {...rest}
    >
      <TextField
        label="Email"
        isRequired={true}
        isReadOnly={false}
        value={Email}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Email: value,
              Enabled,
              GivenName,
              FamilyName,
              Phone,
              Groups,
            };
            const result = onChange(modelFields);
            value = result?.Email ?? value;
          }
          if (errors.Email?.hasError) {
            runValidationTasks("Email", value);
          }
          setEmail(value);
        }}
        onBlur={() => runValidationTasks("Email", Email)}
        errorMessage={errors.Email?.errorMessage}
        hasError={errors.Email?.hasError}
        {...getOverrideProps(overrides, "Email")}
      ></TextField>
      <SwitchField
        label="Enabled"
        defaultChecked={false}
        isDisabled={false}
        isChecked={Enabled}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              Email,
              Enabled: value,
              GivenName,
              FamilyName,
              Phone,
              Groups,
            };
            const result = onChange(modelFields);
            value = result?.Enabled ?? value;
          }
          if (errors.Enabled?.hasError) {
            runValidationTasks("Enabled", value);
          }
          setEnabled(value);
        }}
        onBlur={() => runValidationTasks("Enabled", Enabled)}
        errorMessage={errors.Enabled?.errorMessage}
        hasError={errors.Enabled?.hasError}
        {...getOverrideProps(overrides, "Enabled")}
      ></SwitchField>
      <TextField
        label="Given name"
        isRequired={false}
        isReadOnly={false}
        value={GivenName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Email,
              Enabled,
              GivenName: value,
              FamilyName,
              Phone,
              Groups,
            };
            const result = onChange(modelFields);
            value = result?.GivenName ?? value;
          }
          if (errors.GivenName?.hasError) {
            runValidationTasks("GivenName", value);
          }
          setGivenName(value);
        }}
        onBlur={() => runValidationTasks("GivenName", GivenName)}
        errorMessage={errors.GivenName?.errorMessage}
        hasError={errors.GivenName?.hasError}
        {...getOverrideProps(overrides, "GivenName")}
      ></TextField>
      <TextField
        label="Family name"
        isRequired={false}
        isReadOnly={false}
        value={FamilyName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Email,
              Enabled,
              GivenName,
              FamilyName: value,
              Phone,
              Groups,
            };
            const result = onChange(modelFields);
            value = result?.FamilyName ?? value;
          }
          if (errors.FamilyName?.hasError) {
            runValidationTasks("FamilyName", value);
          }
          setFamilyName(value);
        }}
        onBlur={() => runValidationTasks("FamilyName", FamilyName)}
        errorMessage={errors.FamilyName?.errorMessage}
        hasError={errors.FamilyName?.hasError}
        {...getOverrideProps(overrides, "FamilyName")}
      ></TextField>
      <TextField
        label="Phone"
        isRequired={false}
        isReadOnly={false}
        value={Phone}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Email,
              Enabled,
              GivenName,
              FamilyName,
              Phone: value,
              Groups,
            };
            const result = onChange(modelFields);
            value = result?.Phone ?? value;
          }
          if (errors.Phone?.hasError) {
            runValidationTasks("Phone", value);
          }
          setPhone(value);
        }}
        onBlur={() => runValidationTasks("Phone", Phone)}
        errorMessage={errors.Phone?.errorMessage}
        hasError={errors.Phone?.hasError}
        {...getOverrideProps(overrides, "Phone")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Email,
              Enabled,
              GivenName,
              FamilyName,
              Phone,
              Groups: values,
            };
            const result = onChange(modelFields);
            values = result?.Groups ?? values;
          }
          setGroups(values);
          setCurrentGroupsValue("");
        }}
        currentFieldValue={currentGroupsValue}
        label={"Groups"}
        items={Groups}
        hasError={errors?.Groups?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("Groups", currentGroupsValue)
        }
        errorMessage={errors?.Groups?.errorMessage}
        getBadgeText={getDisplayValue.Groups}
        setFieldValue={setCurrentGroupsValue}
        inputFieldRef={GroupsRef}
        defaultFieldValue={""}
      >
        <SelectField
          label="Groups"
          placeholder="Please select an option"
          isDisabled={false}
          value={currentGroupsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.Groups?.hasError) {
              runValidationTasks("Groups", value);
            }
            setCurrentGroupsValue(value);
          }}
          onBlur={() => runValidationTasks("Groups", currentGroupsValue)}
          errorMessage={errors.Groups?.errorMessage}
          hasError={errors.Groups?.hasError}
          ref={GroupsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "Groups")}
        >
          <option
            children="Administrator"
            value="Administrator"
            {...getOverrideProps(overrides, "Groupsoption0")}
          ></option>
          <option
            children="Auditor"
            value="Auditor"
            {...getOverrideProps(overrides, "Groupsoption1")}
          ></option>
          <option
            children="Contributor"
            value="Contributor"
            {...getOverrideProps(overrides, "Groupsoption2")}
          ></option>
          <option
            children="Editor"
            value="Editor"
            {...getOverrideProps(overrides, "Groupsoption3")}
          ></option>
        </SelectField>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || appUsersModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || appUsersModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
